import { all, call, put, takeLatest } from 'redux-saga/effects'
import SubtitleActions, { SubtitleTypes } from 'Redux/SubtitleRedux'

// Get Subtitle Themes
export function* getSubtitleThemes(api, action) {
  try {
    const resp = yield call(api.getSubtitleThemes)

    if (resp.ok) {
      // Sanitize theme data to plain objects
      const themes = (resp.data || []).map(t => ({
        id: t.id,
        name: t.name,
        description: t.description,
        fontname: t.fontname,
        fontsize: t.fontsize,
        bold: t.bold,
        italic: t.italic,
        alignment: t.alignment,
        has_effect: t.has_effect,
        effect_type: t.effect_type,
        preview: t.preview ? {
          primary_colour: t.preview.primary_colour,
          outline_colour: t.preview.outline_colour,
          back_colour: t.preview.back_colour,
          border_style: t.preview.border_style,
          outline_width: t.preview.outline_width,
          shadow_depth: t.preview.shadow_depth,
        } : null,
      }))
      yield put(SubtitleActions.subtitleThemesSuccess(themes))
      if (action.callback) {
        action.callback(themes, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to fetch subtitle themes'
      yield put(SubtitleActions.subtitleThemesFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to fetch subtitle themes'
    yield put(SubtitleActions.subtitleThemesFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Transcribe Audio (Whisper)
export function* transcribeAudio(api, action) {
  try {
    const resp = yield call(api.transcribeAudio, action.audioId)

    if (resp.ok) {
      yield put(SubtitleActions.subtitleTranscribeSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to transcribe audio'
      yield put(SubtitleActions.subtitleTranscribeFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to transcribe audio'
    yield put(SubtitleActions.subtitleTranscribeFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Regenerate Subtitles with Theme
export function* regenerateSubtitles(api, action) {
  try {
    const resp = yield call(api.regenerateSubtitles, action.audioId, action.style)

    if (resp.ok) {
      yield put(SubtitleActions.subtitleRegenerateSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to regenerate subtitles'
      yield put(SubtitleActions.subtitleRegenerateFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to regenerate subtitles'
    yield put(SubtitleActions.subtitleRegenerateFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Watcher saga
export default function* subtitleSaga(api) {
  yield all([
    takeLatest(SubtitleTypes.SUBTITLE_THEMES_REQUEST, getSubtitleThemes, api),
    takeLatest(SubtitleTypes.SUBTITLE_TRANSCRIBE_REQUEST, transcribeAudio, api),
    takeLatest(SubtitleTypes.SUBTITLE_REGENERATE_REQUEST, regenerateSubtitles, api),
  ])
}
